import { render, staticRenderFns } from "./SOFeedbackReport.vue?vue&type=template&id=410793c6&"
import script from "./SOFeedbackReport.vue?vue&type=script&lang=js&"
export * from "./SOFeedbackReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports